import React, { Component } from 'react';

// Components
import LegalDocumentLayout from '../LegalDocumentLayout';

// Data
import docData from './data';

class TermsOfUse extends Component {
  render() {
    return (
      <LegalDocumentLayout
        docTitle="Terms of Use"
        docData={docData}
      />
    );
  }
}

export default TermsOfUse;



// WEBPACK FOOTER //
// ./src/pages/LegalDocuments/TermsOfUse/TermsOfUse.js